import { picProcess as process } from '@zhiyi/utils'

export const picProcess = (url, config = { params: 'resize,w_1000/quality,Q_90' }) => {
  // 无url，直接跳出
  if (!url || url === null) {
    return
  }
  const { platformConfig, ...otherConfig } = config || {}
  const _config = { params: 'resize,w_1000/quality,Q_90', ...otherConfig }
  return process(url, _config)
}

export const ossImg = (src, w, h) => {
  // 无src，直接跳出
  if (!src || src === null) {
    return
  }
  let suffix = ''
  try {
    const fileArr = src.split('.')
    suffix = fileArr[fileArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  const excludeImgFormat = ['bmp', 'gif', 'webp']
  const hasExclude = excludeImgFormat.some((item) => item === suffix)
  if (hasExclude) {
    return src
  }
  const configHost = ['https://cdn.poizon.com', 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com']
  const flag = configHost.some((host) => src.includes(host))
  if (!flag) {
    return src
  }
  const width = Math.floor(w * 1 * (window.devicePixelRatio || 1))
  const height = Math.floor(h * 1 * (window.devicePixelRatio || 1))
  const _w = w ? `resize,w_${width}` : ''
  const _h = h ? `,h_${height}` : ''
  const _c = '/format,jpg/interlace,1'
  const params = `${_w}${_h}${_c}`
  return picProcess(src, { params })
}

// 淘宝图片cdn
export const cdnImg = (src, w) => {
  const _src = formatDYUrl(src)
  if (!_src || _src === null) {
    return
  }
  if (_src.includes('img.alicdn.com')) return _src
  if (_src.includes('images.asos-media.com/products')) return _src
  return ossImg(_src, w)
}

/**
 * 格式化抖音图片URL
 * @param {string} url
 * @return {string}
 */
export const formatDYUrl = (url) => {
  // https://sf6-ttcdn-tos.pstatp.com/img/temai/a77f55c7ac3af843576c22d1fac9a8d490481109www1280-1280~tplv-resize:200:0.webp
  if (/sf6-ttcdn-tos\.pstatp\.com|sf1-ttcdn-tos\.pstatp\.com/.test(url)) {
    return url.replace(':200:0', ':800:0').replace('.webp', '.jpeg')
  }
  if (/\.byteimg\.com/.test(url)) {
    return url.replace('.webp', '.jpeg')
  }
  return url
}
